
import { FC, useCallback, useMemo, useRef, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Alert, Snackbar, styled } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/CancelOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import AlertContext, { IAlert } from '@/contexts/data/AlertContext';
import IHasChildren from '@/types/components/IHasChildren';


interface IAlertProviderProps extends IHasChildren { }

const StyledAlert = styled(Alert)(({ theme }) => ({
    
}));

const StyledInfoIcon = styled(InfoOutlinedIcon)(({ theme }) => ({

}));

const StyledCheckIcon = styled(CheckIcon)(({ theme }) => ({

}));

const StyledCloseIcon = styled(CloseIcon)(({ theme }) => ({

}));

const AlertProvider: FC<IAlertProviderProps> = ({
    children
}) => {

    const [alerts, setAlerts] = useState<IAlert[]>([]);
    const timerIds = useRef<number[]>([]);

    const removeAlert = useCallback((alert: IAlert) => {
        setAlerts(c => {
            var index = c.indexOf(alert);
    
            if (index === -1) {
                return c;
            }
    
            return c.filter((a, i) => i !== index);
        });

    }, [alerts]);

    const addAlert = useCallback((alert: IAlert) => {
        if (alert.timeout) {
            const timer: { id?: number; } = {
                id: undefined
            };

            timer.id = window.setTimeout(() => {
                removeAlert(alert);
                timerIds.current = timerIds.current.filter(t => t !== timer.id);
            }, alert.timeout);

            timerIds.current.push(timer.id);
        }

        setAlerts(c => {
            return [
                ...c,
                alert
            ]
        });


    }, [alerts, removeAlert]);

    const context = useMemo(() => {
        return {
            alerts,
            addAlert
        }
    }, [alerts, addAlert, removeAlert]);

    return (
        <AlertContext.Provider value={context}>
            {children}
            <Snackbar style={{ marginTop: '40px' }} anchorOrigin={{ vertical: 'top', horizontal: 'right' }} open={alerts.length !== 0}>
                <div>
                    {
                        alerts.map((alert) => (
                            <StyledAlert
                                icon={alert.severity === 'success' ? <StyledCheckIcon /> : alert.severity === 'error' ? <StyledCloseIcon /> : <StyledInfoIcon /> }
                                onClose={alert.dismissable ? () => removeAlert(alert) : undefined} 
                                severity={alert.severity ?? 'success'} 
                                sx={{mt: 2}}
                            >
                                {alert.content}
                            </StyledAlert>
                        ))
                    }
                </div>
            </Snackbar>
        </AlertContext.Provider>
    )
}

export default AlertProvider